import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Cookies from "js-cookie";
import { NavLink } from "react-router-dom";
import { toast } from "react-toastify";
import UpdateTKCSOrderDetails from "./UpdateTKCSOrderDetails";
import AddTKCSOrderDetails from "./AddTKCSOrderDetails";
import Pagination from "../../Common/Pagination/Pagination";
import { sweetAlert } from "../../Common/Utills/Utills";
import _ from "lodash";
import { minDate } from "../../Constants/Constants";

const ViewTKCSOrder = () => {
  const navigate = useNavigate();
  const params = useParams();
  const SERVER_URL = process.env.REACT_APP_SERVER_URL;
  const user_id = Cookies.get("users_id")?.replace(/"/g, "");
  const token = Cookies.get("token")?.replace(/"/g, "");
  const [privateDetails, setPrivateDetails] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalRecords, setTotalRecords] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [rowId, setRowId] = useState("");
  const totalPages = Math.ceil(totalRecords / pageSize);
  const startItem = (currentPage - 1) * pageSize + 1;
  const endItem = Math?.min(
    startItem + privateDetails?.length - 1,
    totalRecords
  );

  const order_id = params.order_id;

  const [filterCriteria, setfilterCriteria] = useState({
    private_order_id: parseInt(order_id),
  });

  const [orderData, setOrderData] = useState([]);
  const getSingleData = async () => {
    let BASE_URL =
      SERVER_URL +
      `/api/private-order/single-private-order/${user_id}/${order_id}`;
    const res = await fetch(BASE_URL, {
      method: "GET",
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
    const result = await res.json();
    if (res.ok) {
      setOrderData(result.data);
    } else {
      setOrderData([]);
    }
  };
  useEffect(() => {
    if (order_id) {
      getSingleData();
    }
  }, [filterCriteria]);

  const handleNavigate = () => {
    navigate("/TKCS-order-detials");
  };

  const onPageChange = (newPage) => {
    setCurrentPage(newPage);
  };

  const onPageSizeChange = (event) => {
    setPageSize(parseInt(event.target.value));
    setCurrentPage(1); // Reset to the first page when page size changes
  };

  const nonEmptyFilterCriteria = Object.fromEntries(
    Object.entries(filterCriteria).filter(
      ([key, value]) => value !== null && value !== undefined && value !== ""
    )
  );

  const options = {
    whereFilters: nonEmptyFilterCriteria,
    skip: currentPage,
    take: pageSize,
  };
  const getData = async () => {
    let BASE_URL =
      SERVER_URL + `/api/private-order/all-private-order-details/${user_id}`;
    const res = await fetch(BASE_URL, {
      method: "post",
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(options),
    });
    const result = await res.json();
    if (res.ok) {
      setTotalRecords(result.total);
      setPrivateDetails(result.data);
    } else {
      setPrivateDetails([]);
    }
  };
  useEffect(() => {
    const fecthDebounced = _.debounce(getData, 500);
    fecthDebounced();
    return () => {
      fecthDebounced.cancel();
    };
  }, [currentPage, pageSize, filterCriteria]);

  const addDataToModal = (id) => {
    setRowId(id);
  };

  const deleteOrderData = async (order_id) => {
    const message = "Do you want to delete this TKCS order details!";

    const result = await sweetAlert(message);

    if (!result.isConfirmed) {
      return;
    }
    let BASE_URL =
      SERVER_URL +
      `/api/private-order/private-order-details/${user_id}/${order_id}`;
    const res = await fetch(BASE_URL, {
      method: "DELETE",
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
    const response = await res.json();
    if (res.ok) {
      setTimeout(() => {
        toast.success(response.message);
      }, 1000);
      getData();
      getSingleData();
    } else {
      toast.error(response.message);
    }
  };
  return (
    <>
      <div className="card">
        <div className="card-body">
          <div className="card-title">
            View TKCS Order Details &nbsp;
            <span>
              <button
                className="btn btn-sm btn-light btn-icon-text border"
                onClick={handleNavigate}
              >
                <i
                  className="mdi mdi-arrow-left"
                  style={{ height: "4px", width: "4px" }}
                ></i>{" "}
                Back{" "}
              </button>
            </span>
          </div>
          <div className="form-container">
            <form className="form-sample">
              {/* <p className="card-description">Personal info</p> */}
              <div className="row">
                <div className="col-md-4">
                  <div className="form-group">
                    <label htmlFor="company_name">Company Name</label>
                    <input
                      type="text"
                      className="form-control"
                      name="company_name"
                      id="company_name"
                      value={
                        orderData?.companyDetails?.company_name +
                        ", " +
                        orderData?.companyDetails?.location
                      }
                      readOnly
                      placeholder="Company Name"
                    />
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="form-group">
                    <label htmlFor="party">Party Name</label>
                    <input
                      type="text"
                      className="form-control"
                      name="party_name"
                      id="party"
                      value={orderData?.party_name}
                      readOnly
                      placeholder="Party Name"
                    />
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="form-group">
                    <label htmlFor="Pole_number">Po.No</label>
                    <input
                      type="text"
                      className="form-control"
                      name="pole_number"
                      id="Pole_number"
                      value={orderData?.po_number}
                      readOnly
                      placeholder="Pole No"
                    />
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group">
                    <label htmlFor="pole_date">Po Date</label>
                    <input
                      type="date"
                      className="form-control"
                      name="date"
                      id="pole_date"
                      value={orderData?.po_date}
                      readOnly
                      placeholder="Pole Date"
                      min={minDate}
                    />
                  </div>
                </div>

                <div className="col-md-6">
                  <div className="form-group">
                    <label htmlFor="terms">Payment Terms</label>
                    <input
                      type="text"
                      className="form-control"
                      name="payment_terms"
                      id="terms"
                      value={orderData?.payment_term}
                      readOnly
                      placeholder="Payment Terms"
                    />
                  </div>
                </div>
                {orderData?.product_quantity_details?.map((item, index) => {
                  return (
                    <React.Fragment key={index}>
                      <div className="col-md-4" key={index}>
                        <div className="form-group">
                          <label htmlFor="quantity">Po Quantity</label>
                          <input
                            type="text"
                            className="form-control"
                            name="pole-qty"
                            id="quantity"
                            value={item?.po_qty}
                            readOnly
                            placeholder="Pole Quantity"
                          />
                        </div>
                      </div>
                      <div className="col-md-4">
                        <div className="form-group">
                          <label htmlFor="Pole">Pole Size</label>
                          <input
                            type="text"
                            className="form-control"
                            name="pole_size"
                            id="Pole"
                            value={item?.size}
                            readOnly
                            placeholder="Pole Size"
                          />
                        </div>
                      </div>
                      <div className="col-md-4">
                        <div className="form-group">
                          <label htmlFor="balance_qty">Balance</label>
                          <input
                            type="text"
                            className="form-control"
                            name="balance_qty"
                            id="balance_qty"
                            value={item?.balance_qty}
                            readOnly
                            placeholder="Balance Qty"
                          />
                        </div>
                      </div>
                    </React.Fragment>
                  );
                })}
              </div>
              <div>
                <h6 style={{ marginTop: "20px" }}>
                  <i className="fa fa-info-circle"></i> Total PO Qty:{" "}
                  {orderData?.total_po_qty}
                </h6>
              </div>
              <div>
                <h6 style={{ marginTop: "20px" }}>
                  <i className="fa fa-info-circle"></i> Total Balance:{" "}
                  {orderData?.total_balance}
                </h6>
              </div>
              {/* <button className="btn btn-primary mr-2 mt-3" type="submit">
              Save
            </button> */}
            </form>
          </div>
        </div>
      </div>

      <div className="card mt-2">
        <div className="card-body">
          {/* <div className="card-title">
            TKCS Order Table &nbsp;
            <span>
              <button
                className="btn btn-sm btn-light btn-icon-text border"
                // onClick={handleRefreshClick}
              >
                Refresh{" "}
                <i
                  className="mdi mdi-refresh"
                  style={{ height: "4px", width: "4px" }}
                ></i>{" "}
              </button>
            </span>
          </div> */}
          <div className="table_btn">
            <div className="mb-3">
              <button
                data-toggle="modal"
                data-target="#exampleModal"
                className="btn btn-outline-primary"
              >
                <span className="mr-1">
                  <i className="mdi mdi-briefcase-upload" />
                </span>
                Add TKCS Order Details
              </button>
            </div>

            <div
              style={{
                marginBottom: "20px",
              }}
            ></div>
          </div>
          <div className="private-table-container">
            <div
              className="table-responsive table-bordered govt-table"
              style={{ border: "0.05px solid lightGray", width: "auto" }}
            >
              <table className="table">
                <thead>
                  <tr>
                    <th>S.NO</th>
                    <th>Circle</th>
                    <th>Product Name</th>
                    <th>Offer Quantity For Inspection</th>
                    <th>Rate</th>
                    <th>GST %</th>
                    <th rowSpan="2">Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {privateDetails && privateDetails.length > 0 ? (
                    privateDetails?.map((item, index) => {
                      return (
                        <React.Fragment key={index}>
                          <tr>
                            {/* <td>{index + 1}</td> */}
                            <td>{(currentPage - 1) * pageSize + index + 1}</td>
                            <td>{item.circle}</td>
                            <td>{item.product_name}</td>
                            <td>{item.po_qty}</td>
                            <td>{item.rate}</td>
                            <td>{item.gst_percent}</td>
                            <td style={{ padding: "10px" }}>
                              <button
                                className="btn btn-outline-secondary btn-sm ml-2"
                                onClick={() => addDataToModal(item.id)}
                                data-toggle="modal"
                                data-target="#updateModal"
                              >
                                <i className="mdi mdi-note-edit-outline" />
                              </button>
                              <button
                                className="btn btn-outline-danger btn-sm ml-2"
                                onClick={() => deleteOrderData(item.id)}
                              >
                                <i className="mdi mdi-delete" />
                              </button>{" "}
                              <NavLink
                                className="btn btn-outline-info btn-sm ml-1"
                                to={
                                  "/view-TKCS-order_details_number/" + item.id
                                }
                              >
                                <i className="mdi mdi-eye-arrow-right-outline" />
                              </NavLink>
                            </td>
                          </tr>
                        </React.Fragment>
                      );
                    })
                  ) : (
                    <tr>
                      <td colSpan="9">
                        <div className="loading-container">
                          <p>No row to show</p>
                        </div>
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
          <AddTKCSOrderDetails
            getData={getData}
            size={orderData?.product_quantity_details}
            order_id={order_id}
            party_name={orderData?.party_name}
          />
          <UpdateTKCSOrderDetails
            getData={getData}
            setRowId={setRowId}
            rowID={rowId}
            size={orderData?.product_quantity_details}
            party_name={orderData?.party_name}
          />
        </div>
        <Pagination
          currentPage={currentPage}
          totalRecords={totalRecords}
          pageSize={pageSize}
          totalPages={totalPages}
          startItem={startItem}
          endItem={endItem}
          onPageChange={onPageChange}
          onPageSizeChange={onPageSizeChange}
        />
      </div>
    </>
  );
};

export default ViewTKCSOrder;
